import { answerFromStoredMessage } from 'actions/team_assist_v2/lib/team_assist_v2_answer';
import TeamAssistRating from 'models/team_assist_rating';

/**
 * The turns of a stored session, from the load route's `messages` and
 * `ratings`: each agent question with its answer, any surfaced tool results,
 * and the agent's rating on the answer. glados returns only answered questions,
 * so a question without an answer is left out.
 */
export default function mapTeamAssistV2Session(messages = [], ratings = []) {
  const ratingsByMessageId = {};
  ratings.forEach(rating => {
    const value = RATING_VALUES_BY_THUMBS[rating.thumbs];
    if (rating.messageId && value) {
      ratingsByMessageId[rating.messageId] = {
        value,
        ...(rating.reason ? { reason: rating.reason } : {}),
        ...(rating.comment ? { comment: rating.comment } : {}),
      };
    }
  });

  const answersByQuestionId = {};
  const executionsByToolUseId = {};
  messages.forEach(message => {
    if (message.role === 'assistant' && message.questionId) {
      answersByQuestionId[message.questionId] = message;
    } else if (message.role === 'tool' && message.kind === 'tool_executed') {
      executionsByToolUseId[message.toolUseId] = {
        result: message.result,
        resultType: message.resultType || null,
        isError: message.isError === true,
      };
    }
  });

  return messages
    .filter(message => message.role === 'agent' && answersByQuestionId[message.id])
    .map(question => ({
      id: question.id,
      question: (question.question && question.question.text) || '',
      displayedMessage: question.displayedMessage,
      conversationId: question.conversationId,
      answer: answerFromStoredMessage(
        answersByQuestionId[question.id],
        executionsByToolUseId,
        ratingsByMessageId[answersByQuestionId[question.id].id] || null
      ),
      live: false,
    }));
}

const RATING_VALUES_BY_THUMBS = {
  up: TeamAssistRating.Value.thumbs_up,
  down: TeamAssistRating.Value.thumbs_down,
};
